import { useState } from 'react';
import { collection, query, where, getDocs, addDoc } from 'firebase/firestore';
import { db } from '../services/firebase';
import { firebaseKeys } from '../utils/constants';

const useSubscribeToNewsLetter = () => {
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const { EMAIL, EMAIL_SUBS } = firebaseKeys;

  const subscribeToNewsLetter = async (email: string) => {
    try {
      const q = query(collection(db, EMAIL_SUBS), where(EMAIL, '==', email));
      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        setError('Email already in use');
        return;
      }

      await addDoc(collection(db, EMAIL_SUBS), {
        email,
        subscriptionDate: new Date(),
      });

      setSuccess(true);
    } catch (err) {
      console.error(err);
      setError('Oops. Something went wrong. Please try again.');
    }
  };
  return { error, setError, subscribeToNewsLetter, success };
};

export default useSubscribeToNewsLetter;
